import { Globe2, ShieldCheck, Bitcoin, MapPin, Phone, ArrowUpRight } from "lucide-react";
import { useI18n } from "../../lib/i18n";
import { PHONE, PHONE_DISPLAY, MAPS_URL } from "../../lib/api";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";

const Card = ({ className = "", children, testid, delay = 0 }) => (
  <Reveal delay={delay} className={`group relative overflow-hidden rounded-[28px] ${className}`} data-testid={testid}>
    {children}
  </Reveal>
);

export const Services = () => {
  const { t } = useI18n();
  const s = t.services;
  return (
    <section id="services" className="bg-[#F1F0EC] py-24 lg:py-28" data-testid="services-section">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <Reveal>
          <Eyebrow>{s.eyebrow}</Eyebrow>
          <SectionTitle title={s.title} accent={s.titleAccent} />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 lg:grid-cols-12 lg:auto-rows-[260px] lg:gap-6">
          <Card className="min-h-[440px] bg-ink lg:col-span-7 lg:row-span-2" testid="service-europe">
            <img src="/img/porsche.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-[1.6s] group-hover:scale-[1.02]" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-7 sm:p-10">
              <Globe2 className="h-8 w-8 text-champagne-light" />
              <h3 className="mt-5 max-w-md font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-white sm:text-3xl">{s.s1t}</h3>
              <p className="mt-4 max-w-md text-base text-zinc-200">{s.s1d}</p>
            </div>
          </Card>

          <Card delay={0.08} className="flex flex-col justify-between border border-ink/10 bg-pearl p-7 sm:p-9 lg:col-span-5" testid="service-guarantee">
            <ShieldCheck className="h-8 w-8 text-champagne-dark" />
            <div>
              <h3 className="font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-ink sm:text-3xl">{s.s2t}</h3>
              <p className="mt-3 text-base text-slate-700">{s.s2d}</p>
            </div>
          </Card>

          <Card delay={0.16} className="flex flex-col justify-between bg-ink p-7 sm:p-9 lg:col-span-5" testid="service-crypto">
            <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-champagne/20 blur-3xl transition-transform duration-700 group-hover:scale-150" />
            <div className="relative flex items-center gap-3">
              <Bitcoin className="h-8 w-8 text-champagne-light" />
              <span className="font-mono text-xs uppercase tracking-[0.24em] text-zinc-300">BTC · ETH · USDT</span>
            </div>
            <div className="relative">
              <h3 className="font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-white sm:text-3xl">{s.s3t}</h3>
              <p className="mt-3 text-base text-zinc-300">{s.s3d}</p>
            </div>
          </Card>

          <Card delay={0.1} className="grid min-h-[300px] grid-cols-1 border border-ink/10 bg-white md:grid-cols-2 lg:col-span-12" testid="service-showroom">
            <div className="relative min-h-[220px] overflow-hidden">
              <img src="/img/interior.jpg" alt="" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.6s] group-hover:scale-[1.02]" />
            </div>
            <div className="flex flex-col justify-between gap-6 p-7 sm:p-10">
              <div>
                <MapPin className="h-8 w-8 text-champagne-dark" />
                <h3 className="mt-5 font-display text-2xl font-extrabold uppercase leading-none tracking-tight text-ink sm:text-3xl">{s.s4t}</h3>
                <p className="mt-3 max-w-md text-base text-slate-700">{s.s4d}</p>
              </div>
              <div className="flex flex-wrap gap-3">
                <a href={`tel:${PHONE}`} className="btn-ink" data-testid="service-showroom-call"><Phone className="h-4 w-4" /> {PHONE_DISPLAY}</a>
                <a href={MAPS_URL} target="_blank" rel="noreferrer" className="btn-ghost" data-testid="service-showroom-map">
                  {t.contact.directions} <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};
